export interface GuideTargetsFiltersType {
  clientIds: string[];
  guideIds: string[];
  targetTypeKeys: string[];
  serviceAreaKeys: string[];
}

export function defaultGuideTargetsFilters(): GuideTargetsFiltersType {
  return {
    clientIds: [],
    guideIds: [],
    targetTypeKeys: [],
    serviceAreaKeys: [],
  };
}
